// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.

import classnames from 'classnames'

import PropTypes from 'prop-types'

import ReactDOM from 'react-dom'
import { HotKeys } from 'react-hotkeys'

import 'styles/components/customer/EditableInfoCard.styl'

const EditableInfoCard = React.createClass({
  mixins: [require('react-onclickoutside')],

  propTypes: {
    save: PropTypes.func.isRequired,
    sections: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object
    ]).isRequired,

    cardTitle: PropTypes.string,
    canSave: PropTypes.bool,
    isEditMode: PropTypes.bool,
    disableSaveOnEnter: PropTypes.bool,
    disableExitOnEscape: PropTypes.bool,
    hasChanged: PropTypes.bool
  },

  getInitialState() { return {
    isEditMode: this.props.isEditMode
  } },

  getDefaultProps() { return {
    canSave: true,
    hasChanged: false
  } },

  componentDidMount() {
    return this.setOutsideClickHandler(this.state.isEditMode)
  },

  componentWillUpdate(nextProps, nextState) {
    return this.setOutsideClickHandler(nextState.isEditMode)
  },

  componentDidUpdate() {
    return this.maybeFocusTextArea()
  },

  renderEditMode(sections) {
    return _.map(sections, section => section.renderEdit())
  },

  renderDisplayMode(sections) {
    return _.map(sections, section => section.renderDisplay())
  },

  renderCardContent(sections) {
    return (
      <div className="card-content">
        {this.props.isEditMode || this.state.isEditMode ?
          <HotKeys
            className="editing-container"
            keyMap={{
              enterPressed: 'enter',
              escapePressed: 'esc'
            }}
            handlers={{
              enterPressed: this.enterPressed,
              escapePressed: this.escapePressed
            }}>
            {this.renderEditMode(sections)}
          </HotKeys>
        :
          this.renderDisplayMode(sections)}
      </div>
    )
  },

  render() {
    const sections = _.compact(this.props.sections)
    const renderedCardContent = this.renderCardContent(sections)

    return (
      <div
        className={classnames('EditableInfoCard', { 'is-focused': this.state.isEditMode })}>
        {this.state.isEditMode ?
          <div className="edit-mode-options-toggles">
            <a className="cancel" onClick={this.cancelEditModeClicked}>
              Cancel
            </a>
            <a
              className={classnames('save', { disabled: !this.props.canSave })}
              onClick={this.saveClicked}>
              Save
            </a>
          </div>
        :
          <a className="edit-toggle" onClick={this.editClicked}>
            Edit
          </a>}
        {this.props.cardTitle ? <div className="card-title">
          {this.props.cardTitle}
        </div> : undefined}
        {this.state.isEditMode ?
          this.props.beforeEdit ?
            <div className="before-edit">
              {this.props.beforeEdit()}
              {renderedCardContent}
            </div>
          :
            renderedCardContent
        :
          this.props.beforeDisplay ?
            <div className="before-display">
              {this.props.beforeDisplay()}
              {renderedCardContent}
            </div>
          :
            renderedCardContent}
      </div>
    )
  },

  maybeFocusTextArea() {
    if (this.state.isEditMode && this.refs.editTextArea) {
      const editTextAreaNode = ReactDOM.findDOMNode(this.refs.editTextArea)
      // check out this neato-burrito hack to move the cursor to the end
      // of a text area, Mom
      const { value } = editTextAreaNode
      editTextAreaNode.focus()
      return editTextAreaNode.value = value
    }
  },

  setOutsideClickHandler(enabled) {
    if (enabled) {
      return this.enableOnClickOutside()
    } else {
      return this.disableOnClickOutside()
    }
  },

  handleClickOutside() {
    if (!this.props.hasChanged) {
      return this.cancelEditModeClicked()
    }
  },

  cancelEditModeClicked() {
    this.setState({ isEditMode: false })
    return this.props.reset()
  },

  saveClicked() {
    return this.maybeSaveAndCloseEdit()
  },

  enterPressed() {
    if (!this.props.disableSaveOnEnter) { return this.maybeSaveAndCloseEdit() }
  },

  escapePressed() {
    if (!this.props.disableExitOnEscape) { return this.cancelEditModeClicked }
  },

  maybeSaveAndCloseEdit() {
    if (!this.props.canSave) { return }
    this.setState({ isEditMode: false })
    return this.props.save()
  },

  editClicked() {
    return this.setState({ isEditMode: true })
  }
})

export default EditableInfoCard



// WEBPACK FOOTER //
// ./src/scripts/components/customer/EditableInfoCard.js